/* Quick add-ons rail on the product page.

   Replaces the Liquid rail with Shopify's own recommendations for the product
   being viewed, in the same priority order the cart drawer uses:

     1. complementary  pairs curated in the Search & Discovery app.
     2. related        Shopify's algorithm over real order history and product
                       similarity - what other customers bought with this.
     3. the Liquid rail, left untouched if both return nothing, so the rail is
        never emptied.

   Two things differ from the cart drawer:

     * The seed is the product on the page, not the basket. The old Liquid rail
       recommended from whatever happened to be in the cart, which on a product
       page is the wrong question - it would show add-ons for a different item
       entirely, or nothing at all on an empty cart.

     * Same-brand cards are ordered FIRST. On a product page "more from this
       brand" is a natural next step, and the request was to lean into it here.
       The cart drawer does the opposite, for the reason explained there.

   Cards are rendered by sections/quick-add-recommendations rather than being
   rebuilt here, so money formatting, the discount badge and the add-to-cart
   button keep working. */
(function () {
  var SECTION = 'quick-add-recommendations';
  var TARGET_COUNT = 12;
  var RAIL = '.quick-add-slider[data-quick-add-rail]';

  var running = false;

  function fetchIntent(productId, intent, limit) {
    var url = '/recommendations/products?section_id=' + SECTION +
              '&product_id=' + productId +
              '&intent=' + intent +
              '&limit=' + limit;
    return fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return [];
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('.quick-add-slide'));
      })
      .catch(function () { return []; });
  }

  /* Collect cards, skipping the product itself, anything already in the cart,
     and duplicates across the two intents. */
  function take(cards, picked, skipHandles) {
    for (var i = 0; i < cards.length; i++) {
      var handle = cards[i].getAttribute('data-product-handle');
      if (!handle || skipHandles[handle] || picked.handles[handle]) continue;
      picked.handles[handle] = true;
      picked.cards.push(cards[i]);
    }
  }

  /* Same brand first, everything else after, each keeping the order the
     recommendation engine returned it in. */
  function brandFirst(cards, vendor) {
    if (!vendor) return cards;
    var same = [], other = [];
    cards.forEach(function (c) {
      var v = c.getAttribute('data-product-vendor') || '';
      (v && v === vendor ? same : other).push(c);
    });
    return same.concat(other);
  }

  function build() {
    var rail = document.querySelector(RAIL);
    if (!rail || running) return;

    var seed = rail.getAttribute('data-seed-product-id');
    if (!seed) return;
    var vendor = rail.getAttribute('data-seed-vendor') || '';

    running = true;

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { items: [] }; })
      .catch(function () { return { items: [] }; })
      .then(function (cart) {
        var skip = {};
        (cart.items || []).forEach(function (i) { if (i.handle) skip[i.handle] = true; });

        var picked = { cards: [], handles: {} };

        return fetchIntent(seed, 'complementary', TARGET_COUNT)
          .then(function (cards) {
            take(cards, picked, skip);
            if (picked.cards.length >= TARGET_COUNT) return [];
            return fetchIntent(seed, 'related', TARGET_COUNT);
          })
          .then(function (cards) {
            take(cards, picked, skip);

            // Nothing usable: leave the Liquid rail rather than empty the rail.
            if (!picked.cards.length) return;

            var target = document.querySelector(RAIL);
            if (!target) return;

            var ordered = brandFirst(picked.cards, vendor).slice(0, TARGET_COUNT);
            target.innerHTML = '';
            ordered.forEach(function (c) { target.appendChild(c); });

            // Arrows, dots and scroll handlers close over the slides present
            // when they were wired, so they need a fresh pass over the new ones.
            if (typeof window.initQuickAddSliders === 'function') {
              window.initQuickAddSliders();
            }
            if (typeof window.hideProductsInCart === 'function') {
              window.hideProductsInCart();
            }
          });
      })
      .catch(function () { /* leave the Liquid rail in place */ })
      .then(function () { running = false; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(build, 300); });
  } else {
    setTimeout(build, 300);
  }
})();
